export enum FeatureFlag {
  ALLOW_OM_CREATE_NEW_FILE = 'ordermanagement-2346561-ui-create-new-file',
  SHOW_REMITTANCE_RECEIVABLES_NAVIGATION = 'ordermanagement-2367286-ui-remittance-receivables-navigation',
}
